import { Button, Stack, Typography } from '@mui/material'
import React, { useState } from 'react'
import PatientLookup from '../NewBooking/PatientLookup'
import { useNavigate } from 'react-router-dom'
import { PersonAddAlt1, PersonSearch } from '@mui/icons-material'
import AddNewPatient from '../NewPatient/AddNewPatient'

const PTSPatientList = () => {
  const navigate = useNavigate()
  const [openAddNewPatient, setOpenAddNewPatient] = useState(false)
  return (
    <Stack gap={1}>
      <AddNewPatient
        open={openAddNewPatient}
        onClose={() => {
          setOpenAddNewPatient(false)
        }}
        actionAfterSubmit={(newPatient) => {
          navigate(newPatient._id)
        }}
      />
      <PatientLookup
        embedded={true}
        customAction={(patientID) => navigate(patientID)}
        createNewPT={setOpenAddNewPatient}
        onRowClick={(patient) => navigate(patient._id)}
      />
    </Stack>
  )
}

export default PTSPatientList
